<template>
  <div class="blankpage">
    <div class="blankpage-card">
      <div class="blankpage-spinner"></div>
      <div class="blankpage-title">正在进行微信登录</div>
      <div class="blankpage-desc">检测到当前为微信环境，系统正在自动登录并返回原页面，请稍候...</div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      codes: "",
    };
  },
  created() {
    //检测是否为微信内置浏览器
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      try {
        window.sessionStorage.clear();
      } catch (error) {}
      this.initData();
    } else {
      this.$router.replace(this.getRedirectPayload());
    }
  },
  methods: {
    initData() {
      const appid = "wx4fe4938f6fa25eb2";
      const local = this.getAuthorizeRedirectUrl();
      const code = this.getUrl("code");
      let url =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        appid +
        "&redirect_uri=" +
        encodeURIComponent(local) +
        "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
      if (code == null || code == "") {
        window.location.href = url;
      } else {
        this.codes = code;
        this.queryData();
      }
    },
    getUrl(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getAuthorizeRedirectUrl() {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete("code");
      currentUrl.searchParams.delete("state");
      currentUrl.searchParams.delete("appid");
      currentUrl.searchParams.delete("scope");

      return currentUrl.toString();
    },
    getRedirectPayload() {
      const query = { ...this.$route.query };
      const currentpath = query.currentpath || "/";

      delete query.currentpath;
      delete query.code;
      delete query.state;
      delete query.appid;
      delete query.scope;

      return {
        path: currentpath,
        query,
      };
    },
    queryData() {
      this.$http
        .getLogin({ code: this.codes })
        .then((res) => {
          const openId = res.user.weixin_openid;
          const access_token = res.access_token;
          const nick_name = res.user.nick_name;
          const avatar = res.user.avatar;
          const datas = JSON.stringify(res.user);
          window.sessionStorage.setItem("openId", openId);
          window.sessionStorage.setItem("nick_name", nick_name);
          window.sessionStorage.setItem("avatar", avatar);
          window.sessionStorage.setItem("user_id", res.user.id || "");
          window.sessionStorage.setItem("username", res.user.phone || `用户${res.user.id}`);
          window.sessionStorage.setItem("Token", access_token);
          window.sessionStorage.setItem("user", datas);
          this.$router.replace(this.getRedirectPayload());
          // window.location.href = `/p/#${this.$route.query.currentpath}`;
        })
        .catch((err) => {
          console.log(err, "失败");
          Toast.fail("微信登录失败，请重试");
          this.$router.replace("/home");
        });
    },
  },
};
</script>

<style>
.blankpage {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.4rem;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f6f8fb 0%, #eef3f9 100%);
}

.blankpage-card {
  width: 100%;
  max-width: 5.8rem;
  padding: 0.56rem 0.42rem;
  border-radius: 0.24rem;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 0.16rem 0.48rem rgba(15, 23, 42, 0.08);
  text-align: center;
}

.blankpage-spinner {
  width: 0.72rem;
  height: 0.72rem;
  margin: 0 auto 0.24rem;
  border-radius: 50%;
  border: 0.06rem solid #dbe5f0;
  border-top-color: #1f9dff;
  animation: blankpage-spin 0.9s linear infinite;
}

.blankpage-title {
  font-size: 0.34rem;
  font-weight: 600;
  color: #1f2937;
}

.blankpage-desc {
  margin-top: 0.14rem;
  font-size: 0.26rem;
  line-height: 1.6;
  color: #6b7280;
}

@keyframes blankpage-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
